import { graphql } from "react-relay";

export const UpdateJobMutation = graphql`
  mutation UpdateJobMutation($input: UpdateJobInput!) {
    updateJob(input: $input) {
      job {
        id
        name
        inputJson
        schedule
        taskType
        status
        latestPromptFeedback {
          id
          suggestions {
            name
            isStale
          }
        }
      }
    }
  }
`;